import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/data/content";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  return (
    <section id="reviews" className="py-20 md:py-32 bg-[hsl(var(--bg-2))]/60" data-testid="testimonials">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16">
          <div className="eyebrow mb-4 justify-center">Testimonials</div>
          <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-[-0.02em]">
            What our patients <span className="text-[hsl(var(--primary))]">are saying</span>
          </h2>
          <p className="mt-5 md:mt-6 text-[15px] md:text-base text-[hsl(var(--ink-soft))]">
            Patients from across Mumbai trust Calm Dentistry for gentle, expert care and a calming clinic experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.06 }}
              className="card-soft p-6 md:p-8 flex flex-col justify-between min-h-[240px] md:min-h-[280px]"
              data-testid={`testimonial-${i}`}
            >
              <div>
                <div className="w-10 h-10 rounded-xl bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))] flex items-center justify-center mb-4">
                  <Quote size={18} strokeWidth={1.8} />
                </div>
                <p className="text-[15px] text-[hsl(var(--ink-soft))] leading-relaxed">&ldquo;{t.body}&rdquo;</p>
              </div>
              <figcaption className="mt-6 pt-6 border-t border-[hsl(var(--line))]/70 flex items-center justify-between">
                <div>
                  <div className="font-display text-base">{t.name}</div>
                  <div className="text-[12px] text-[hsl(var(--ink-soft))] mt-1">{t.city}</div>
                </div>
                <div className="flex text-[hsl(var(--primary))]">
                  {[0,1,2,3,4].map(k => <Star key={k} size={13} className="fill-current" />)}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
